import { ReactNode } from 'react';
import WidgetContainer, { IWidgetContainer } from '../WidgetContainer';
import Grid from '../Grid';

export { default as ToggledSetting } from './components/ToggledSetting';

export interface IToggledSettingsProps extends Omit<IWidgetContainer, 'title'> {
  children: ReactNode;
}

const ToggledSettings = (props: IToggledSettingsProps) => {
  const { children, ...restWidgetContainerProps } = props;
  return (
    <WidgetContainer container withShadow p={3} {...restWidgetContainerProps}>
      <Grid container item rowGap={3}>
        {children}
      </Grid>
    </WidgetContainer>
  );
};

export default ToggledSettings;
